import React, {useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {Modal} from "peggirkit";
import {KeyphraseDensityScore} from "./KeyphraseDensityChecker";
import ScoreIndicator from "../../../../elements/scoreIndicator/ScoreIndicator";
import {globalModalStyling} from "../../../../elements/modal/modalStyle";

type Props = {
    result?: KeyphraseDensityScore
};

const KeyphraseDensityScoreIndicator = ({result}: Props) => {
    const intl = useIntl();
    const [showExplanation, setShowExplanation] = useState(false);

    if (!result) {
        return <>-</>;
    }

    return (
        <>
            <ScoreIndicator
                score={result.score}
                onClick={() => setShowExplanation(true)}
            />

            <Modal
                {...globalModalStyling(intl)}
                show={showExplanation}
                onClose={() => setShowExplanation(false)}
                title={intl.formatMessage({id: "keyphraseDensity"})}
            >
                <div className={"flex flex-col gap-6"}>
                    <p>
                        <FormattedMessage id="keyphraseDensity.description-1"/>
                    </p>
                    <p>
                        <FormattedMessage id="keyphraseDensity.description-2"/>
                    </p>
                    <p>
                        <FormattedMessage id="keyphraseDensity.description-3"/>
                    </p>
                    <p>
                        <span className={"text-black dark:text-white font-medium"}>
                            <FormattedMessage
                                id="keyphraseDensity.description-4"
                                values={{
                                    keyphraseWordCount: result.keyphraseWordCount,
                                    wordCount: result.wordCount,
                                    densityPercentage: result.densityPercentage
                                }}
                            />
                        </span>
                    </p>
                </div>
            </Modal>
        </>
    );
};

export default KeyphraseDensityScoreIndicator;